import { ContextualSaveBar } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"

import UnsavedChangesModal from "./UnsavedChangesModal"

interface AdminSaveModuleProps {
  onSave: () => void
  onDiscard: () => void
  show: boolean
  loading?: boolean
  disabled?: boolean
  subRouteBlock?: boolean
  title?: string
  message?: string
  secondaryLabel?: string
  allowedPaths?: string[]
  isTrackingPage?: boolean
}

const AdminSaveModule: React.FC<AdminSaveModuleProps> = ({
  onSave,
  onDiscard,
  show,
  loading = false,
  disabled = false,
  subRouteBlock = false,
  title,
  message,
  secondaryLabel,
  allowedPaths = [],
  isTrackingPage = false,
}) => {
  const { t } = useTranslation("common")

  return (
    <>
      <UnsavedChangesModal
        when={show}
        title={title}
        message={message}
        secondaryLabel={secondaryLabel}
        onConfirm={onDiscard}
        allowedPaths={allowedPaths}
        isTrackingPage={isTrackingPage}
      />

      {show && (
        <ContextualSaveBar
          message={t("UnsavedChanges")}
          fullWidth
          alignContentFlush
          saveAction={{
            content: t("Save"),
            disabled,
            loading,
            onAction: onSave,
          }}
          discardAction={{
            content: t("Discard"),
            onAction: onDiscard,
          }}
        />
      )}
    </>
  )
}

export default AdminSaveModule
